export default "__VITE_ASSET__Mhvs9oAf__"